// ── window.claude shim ────────────────────────────────────────────────
// Pages and ai-chat.jsx call `window.claude.complete(prompt)`. In the dev
// agent harness this is provided implicitly; on Cloudflare Pages it must be
// wired to our /api/claude proxy (functions/api/claude.js).
//
// This shim ALWAYS assigns window.claude in production builds. If
// window.claude is already defined (dev / sandbox), we leave it alone so
// authoring works without a backend round-trip.

(function (root) {
  // Already provided by the host runtime — don't clobber
  if (root.claude && typeof root.claude.complete === 'function') return;

  async function complete(prompt) {
    // Use the current Supabase session's access token as the bearer
    const sb = root.sbClient;
    const { data } = sb ? await sb.auth.getSession() : { data: { session: null } };
    const token = data?.session?.access_token;
    if (!token) throw new Error('No session — sign in first.');

    const res = await fetch('/api/claude', {
      method:  'POST',
      headers: {
        'content-type':  'application/json',
        'authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ prompt }),
    });
    if (!res.ok) {
      let detail = '';
      try { detail = (await res.json())?.error || ''; } catch {}
      throw new Error(`AI error ${res.status}${detail ? ': ' + detail : ''}`);
    }
    const out = await res.json();
    return out?.text || '';
  }

  root.claude = { complete };
})(typeof window !== 'undefined' ? window : globalThis);
